import * as React from "react";
import { Redirect } from "react-router-dom";

type RedirecterProps = { to?: string };
export const Redirecter = ({to}: RedirecterProps) => {
	return (<Redirect to={to ? to : "/"}/>);
};
